import { Component, ElementRef, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ListPolIntValidTokenSusPeticion } from 'src/app/models/completar-suscripcion/listPolIntValidTokenSusPeticion';
import { ListSuscripcionPeticion } from 'src/app/models/completar-suscripcion/listSuscripcionPeticion';
import { CompletarSuscripcionService } from 'src/app/services/completar-suscripcion/completarSuscripcion.service';
import { Estilos } from 'src/app/services/estilos/estilos';
import { LoaderBaseService } from 'src/app/services/loader-base.service';
import { DialogBaseComponent } from '../dialog-base/dialog-base.component';
import { AutenticadorService } from 'src/app/services/autenticador/autenticador.service';
import { PreLoginPeticion } from 'src/app/models/pre-login/PreLogin-peticion';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
export interface DialogData {
  title: string;
  content: string;
  showBtnCancel: boolean;
}

@Component({
  selector: 'lib-dialog-token-suscripcion',
  templateUrl: './dialog-token-suscripcion.component.html',
  styleUrls: ['./dialog-token-suscripcion.component.css'],
  providers: [CompletarSuscripcionService]
})
export class DialogTokenSuscripcionComponent {
  estilos : Estilos = new Estilos();
  listSuscripcionPeticion: ListSuscripcionPeticion = new ListSuscripcionPeticion();
  listPolIntValidTokenSusPeticion: ListPolIntValidTokenSusPeticion = new ListPolIntValidTokenSusPeticion();
  errorValidarToken: boolean = false;
  errorMensage: string = "";
  maxIntentoTokenSusBD: number = 0;
  maxIntentoTokenSus: number = 0;
  preLoginsLS: { codTpoPortal: string; };
  isEmbebido = false;
  formGroup: FormGroup = new FormGroup({
    tokenSuscripcion: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20)]))
  });

  constructor(
    public dialogRef: MatDialogRef<DialogTokenSuscripcionComponent>,
    private loader: LoaderBaseService,
    private completarSuscripcionService: CompletarSuscripcionService,
    public dialog: MatDialog,
    private autenticatorService: AutenticadorService,
    private router: Router,
    @Inject('env') private environment: any,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private elementRef: ElementRef
    ) {
      this.estilos.cambioEstilos(elementRef);
     }

  ngOnInit() {
    //this.listPolIntValidTokenSusPeticion.codCliente = this.environment.codCliente;
    //this.postListPolIntValidTokenSusServices(this.listPolIntValidTokenSusPeticion);
    this.preLoginsWait();
  }

  preLoginsWait(){
    let params: PreLoginPeticion = new PreLoginPeticion();
    params.codCliente = environment.codCliente;
    params.urlPortal = environment.urlPortal;

    this.autenticatorService.preLogin(params).subscribe(data => {
      if (data.codret == '0') {
        sessionStorage.setItem('preLogin', JSON.stringify(data));
        sessionStorage.setItem('tokenSession', data.tokenSession);

        this.preLoginsLS = JSON.parse(sessionStorage.getItem('preLogin'));

        this.configSusComercio();
      } else {
        this.onNoClick(false);
      }
    }, error => {
      this.onNoClick(false);
      sessionStorage.setItem('preLoginError', JSON.stringify(error));
      this.router.navigate(['/mantencion']);
    });
  }

  configSusComercio() {
    this.autenticatorService.getLoginSusComercio().subscribe(data => {
      if (data.codret == '0') {
        sessionStorage.setItem('tokenSessionSusComercio', data['tokenSession']);

        this.listPolIntValidTokenSusPeticion.codCliente = this.environment.codCliente;
        this.postListPolIntValidTokenSusServices(this.listPolIntValidTokenSusPeticion);
      } else {
        this.onNoClick(false);
      }
    }, err => {
      console.error('error: ', err);
      this.onNoClick(false);
    });
  }

  postListPolIntValidTokenSusServices(body: ListPolIntValidTokenSusPeticion) {
    this.loader.show();
    this.completarSuscripcionService.postListPolIntValidTokenSus(body, this.isEmbebido).subscribe(data => {
      if(data.codret == '0'){
        this.loader.hide();
        this.maxIntentoTokenSusBD = data.resultado[0]['maxIntentoTokenSus'];
        this.maxIntentoTokenSus = this.maxIntentoTokenSusBD;
      }else{
        this.removeSession();
        this.loader.hide();
        this.onNoClick(false);
        this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
      }
    }, err => {
      console.error('error: ', err);
      this.removeSession();
      this.loader.hide();
      this.onNoClick(false);
      this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
    });
  }

  validarToken(){
    if(this.maxIntentoTokenSusBD == 0){
      this.listSuscripcionPeticion.tokenSuscripcion = this.formGroup.get('tokenSuscripcion').value;
      this.listSuscripcionPeticion.codCliente = this.environment.codCliente;
      this.postListSusComercioServices(this.listSuscripcionPeticion);
    } else if (this.maxIntentoTokenSus > 0){
      this.listSuscripcionPeticion.tokenSuscripcion = this.formGroup.get('tokenSuscripcion').value;
      this.listSuscripcionPeticion.codCliente = this.environment.codCliente;
      this.postListSusComercioServices(this.listSuscripcionPeticion);
    }else{
      this.onNoClick(false);
      this.showDialog('Error', 'Ha excedido la cantidad de intentos permitidos.', false, 'Cancelar', 'Aceptar');
    }
  }

  postListSusComercioServices(body: ListSuscripcionPeticion) {
    this.loader.show();
    this.errorValidarToken = false;
    this.completarSuscripcionService.postListSusComercio(body, this.isEmbebido).subscribe(data => {
      if(data.codret == '0'){
        this.loader.hide();
        sessionStorage.setItem('listSusComercio', JSON.stringify(
          data['resultado'][0]
        ));
        this.onNoClick(true);
      } else if (data.codret == '-100'){
        this.loader.hide();
        this.maxIntentoTokenSus--;
        this.errorValidarToken = true;
        this.errorMensage = "Token no existe o no se encuentra vigente.";
      } else {
        this.removeSession();
        this.loader.hide();
        this.onNoClick(false);
        this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
      }
    }, err => {
      console.error('error: ', err);
      this.removeSession();
      this.loader.hide();
      this.onNoClick(false);
      this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
    });
  }

  onNoClick(valor): void {
    this.dialogRef.close(valor);
  }

  showDialog(pTitle: string, pContent: string, pShowBtnCancel: boolean, pBtnCancelar: string, pBtnAceptar: string) {
    const dialogRef = this.dialog.open(DialogBaseComponent, {
      data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel, btnCancelar: pBtnCancelar, btnAceptar: pBtnAceptar},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {}
    });
  }

  removeSession() {
    sessionStorage.removeItem('tokenSessionSusComercio');
    sessionStorage.removeItem('listSusComercio');
  }

}
